import { AgilePointServiceClient } from '@agilepoint/wat';
import { toCamelCasedKeys } from '@agilepoint/utils-common';
import { createDependency } from '@agilepoint/restate-core';
import { getUserProfilePayloadDefault } from '../defaults';
export class CoreApiClient {
    static create(agilepointServiceClient: AgilePointServiceClient) {
        return new CoreApiClient(agilepointServiceClient);
    }

    constructor(private agilepointServiceClient: AgilePointServiceClient) { }

    getLoggedUserDetails(userName: string) {
        return this.agilepointServiceClient.getJSON(`GetTextData/UserProfile_${userName.replace('\\', '_')}`)
            .then(userDetails => toCamelCasedKeys(JSON.parse(userDetails.TextData), true))
            .catch((e) => {
                console.log('User details is empty');
                console.log('Error', e);
                return (getUserProfilePayloadDefault(userName));
            }) as Promise<any>;
    }
}

export const coreApiClientDependency = createDependency<CoreApiClient>(Symbol('CoreApiClient'));
